/* eslint-disable react/jsx-props-no-spreading, react/prop-types */
import classnames from 'classnames';
import { colord } from "colord";

// below here for testing imports
import { RangeControl } from '@wordpress/components';

const { assign, merge } = lodash;
const { __ } = wp.i18n;
const { PanelBody,ToggleControl } = wp.components;



const TransformsPanel = (myprops) => {

	const props = myprops.props;
	const {attributes,setAttributes} = props;
	const {overflowhidden,aplotransforms,aplotransformsHover,hasTransforms,hasHoverTransforms} = attributes;

	function rangeControl(thename, min, max) {

		function updateValue(value) {
			if (value === undefined && aplotransforms === undefined) {return};
			if (value === undefined) { // value is undefined then we may be removing a value
				// if the old value is not undefined the value is undefined then remove the value
				if (aplotransforms !== undefined && aplotransforms[thename] !== undefined) {
					hasTransforms === 1 ? setAttributes({aplotransforms:undefined}) : setAttributes({aplotransforms:{...aplotransforms,[thename]:undefined}});
					setAttributes({hasTransforms:hasTransforms - 1 });
				}
			} else { //  the value is defined, adding or changing value
				if (aplotransforms === undefined || aplotransforms[thename] === undefined) { setAttributes({hasTransforms:hasTransforms + 1}); };
				setAttributes({aplotransforms:{...aplotransforms,[thename]:value}});
			}
		}

		return(
			<RangeControl
				/*label={thename}*/
				value={ aplotransforms !== undefined ? aplotransforms[thename] : undefined}
				onChange={ updateValue }
				min={ min }
				max={ max }
				step={1}
				allowReset={true}
			/>
		);
	}

	function rangeControlHover(thename, min, max,type) {	

		function updateValue(value) {
			if (value === undefined && aplotransformsHover === undefined) {return};
			if (value === undefined) { // value is undefined then we may be removing a value
				// if the old value is not undefined the value is undefined then remove the value
				if (aplotransformsHover !== undefined && aplotransformsHover[thename] !== undefined) {
					hasHoverTransforms === 1 ? setAttributes({aplotransformsHover:undefined}) : setAttributes({aplotransformsHover:{...aplotransformsHover,[thename]:undefined}});
					setAttributes({hasHoverTransforms:hasHoverTransforms - 1 });
				}
			} else { //  the value is defined, adding or changing value
				if (aplotransformsHover === undefined || aplotransformsHover[thename] === undefined) { setAttributes({hasHoverTransforms:hasHoverTransforms + 1}); };
				setAttributes({aplotransformsHover:{...aplotransformsHover,[thename]:value}});
			}
		}

		return(
			<RangeControl
				/*label={thename}*/
				value={ aplotransformsHover !== undefined ? aplotransformsHover[thename] : undefined}
				onChange={ updateValue }
				min={ min }
				max={ max }
				step={1}
				allowReset={true}
			/>
		);
	}

	return (

		<PanelBody title={__('Aplo Transform Styles', 'aploblocks')} initialOpen={false} className="aplofilterstyles">
						
			<ToggleControl
				label={__('Hide overflow')}
				checked={ overflowhidden }
				onChange={ (state) => {
					//const att = state ? state : undefined;
					setAttributes({ overflowhidden: state })
				} }
			/>			
		
			<p>{__('Set the normal and hover values for each transform.  The left hand value is normal and the right hand value is hover','aploblocks')}</p>
			<div class="aploranges">
				<h2>{__('Scale','aploblocks')}</h2>
				<div class="aplorange">
					{rangeControl("scale",1,200)}
					{rangeControlHover("scale",1,200)}
				</div>
				<h2>{__('Rotate','aploblocks')}</h2>
				<div class="aplorange">
					{rangeControl("rotate",-180,180)}
					{rangeControlHover("rotate",-180,180)}
				</div>
				<h2>{__('Move Horizontal','aploblocks')}</h2>
				<div class="aplorange">
					{rangeControl("translateX",-200,200)}
					{rangeControlHover("translateX",-200,200)}
				</div>
				<h2>{__('Move Vertical','aploblocks')}</h2>
				<div class="aplorange">
					{rangeControl("translateY",-200,200)}
					{rangeControlHover("translateY",-200,200)}
				</div>
			</div>
		</PanelBody>



	)



}



export default TransformsPanel